module.exports = __webpack_public_path__ + "static/media/1.c7765e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/400/1.png
// module id = 1306
// module chunks = 0